import { describeFields, FieldWidget } from '../common/fields';
import { LegacyExamAttemptSchema } from './schemas';

export const LEGACY_EXAM_ATTEMPT_FIELDS = describeFields(LegacyExamAttemptSchema, {
  student: {},
  studentDetails: {},
  examId: {},
  examLabel: {},
  attemptNumber: {},
  markerId: {},
  dueDatetime: {},
  markedDatetime: {},
  creationDatetime: {},
  outcome: { widget: FieldWidget.Text },
  mark: { widget: FieldWidget.Text },
  maxMark: { widget: FieldWidget.Text },
});
